document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('input[name="q"]');

  if (!searchInput) return;

  const searchForm = searchInput.closest('form[action*="/search"]');

  if (!searchForm) return;

  // Create the predictive-search dropdown
  const dropdown = document.createElement('div');
  dropdown.className = 'predictive-search-dropdown';
  dropdown.setAttribute('role', 'listbox');
  searchForm.appendChild(dropdown);

  let debounceTimer;

  searchInput.addEventListener('input', function (event) {
    const query = event.target.value.trim();

    clearTimeout(debounceTimer);

    // Begin searching after two characters
    if (query.length < 2) {
      closeDropdown(dropdown);
      return;
    }

    debounceTimer = setTimeout(function () {
      fetchPredictiveResults(query, dropdown);
    }, 300);
  });

  // Close the dropdown when clicking outside the search form
  document.addEventListener('click', function (event) {
    if (!searchForm.contains(event.target)) {
      closeDropdown(dropdown);
    }
  });

  // Close the dropdown when pressing Escape
  searchInput.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDropdown(dropdown);
    }
  });
});

function fetchPredictiveResults(query, dropdown) {
  const root =
    window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

  const url =
    `${root}search/suggest.json` +
    `?q=${encodeURIComponent(query)}` +
    `&resources[type]=product` +
    `&resources[limit]=10` +
    `&resources[options][fields]=title`;

  fetch(url)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(`Shopify search returned ${response.status}`);
      }

      return response.json();
    })
    .then(function (data) {
      renderResults(data, dropdown, query);
    })
    .catch(function (error) {
      console.error('Predictive search error:', error);
      closeDropdown(dropdown);
    });
}

function renderResults(data, dropdown, query) {
  const results =
    data &&
    data.resources &&
    data.resources.results
      ? data.resources.results
      : {};

  const queryLower = query.toLowerCase();

  // Only display products whose titles begin with the typed letters
  const products = (results.products || []).filter(function (product) {
    return product.title
      .trim()
      .toLowerCase()
      .startsWith(queryLower);
  });

  let html = '';

  products.forEach(function (product) {
    const imageUrl =
      product.featured_image && product.featured_image.url
        ? product.featured_image.url
        : product.image || '';

    const imageHtml = imageUrl
      ? `
        <img
          src="${escapeHtml(imageUrl)}"
          alt="${escapeHtml(product.title)}"
          class="predictive-search-image"
        >
      `
      : '';

    const price = Number(product.price);

    const priceHtml = Number.isFinite(price)
      ? `
        <span class="predictive-search-price">
          ${formatMoney(price)}
        </span>
      `
      : '';

    html += `
      <a
        href="${escapeHtml(product.url)}"
        class="predictive-search-item predictive-search-product"
        role="option"
      >
        ${imageHtml}

        <div class="predictive-search-product-info">
          <span class="predictive-search-text">
            ${escapeHtml(product.title)}
          </span>

          ${priceHtml}
        </div>
      </a>
    `;
  });

  if (products.length > 0) {
    html += `
      <a
        href="/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last"
        class="predictive-search-view-all"
      >
        View all results for “${escapeHtml(query)}”
      </a>
    `;
  } else {
    html = `
      <div class="predictive-search-no-results">
        No products found
      </div>
    `;
  }

  dropdown.innerHTML = html;
  dropdown.style.display = 'block';
}

function formatMoney(amount) {
  const currency =
    window.Shopify &&
    window.Shopify.currency &&
    window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(amount);
}

function closeDropdown(dropdown) {
  dropdown.innerHTML = '';
  dropdown.style.display = 'none';
}

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, function (character) {
    const characters = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };

    return characters[character];
  });
}